<template>
  <div>
    <div id="workup-container" v-bind:style="hide ? 'display:none' : 'display:block'">
      <div class="workup-chat" id="workup-chat" :class="{ show: workupChatOpenFlag }">
        <!-- <div class="workup-fullscreen-close" id="workup-fullscreen-close" @click="workupBtnElementClick">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 64.19 64.19" xml:space="preserve">
            <defs>
              <svg:style type="text/css">
                .workup-bg{fill:{{ workupBg }}}
                .workup-x{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2.73px;}
              </svg:style>
            </defs>
            <title>close</title>
            <g data-name="workup-close">
              <circle cx="32.1" cy="32.1" r="32.1" class="workup-bg"></circle>
              <line x1="41.58" x2="22.62" y1="22.28" y2="41.24" class="workup-x"></line>
              <line x1="41.58" x2="22.62" y1="41.24" y2="22.28" class="workup-x"></line>
            </g>
          </svg>
        </div> -->
        <chat-body :tenantKey="tenantKey" @close-chat="workupBtnElementClick"></chat-body>
      </div>
      <chat-status-msg v-bind:style="firstClick ? 'display:none' : 'display:block'"></chat-status-msg>
      <div class="workup-launcher" :class="{ active: workupChatOpenFlag }" id="workup-launcher"
        v-show="workupLauncherReadyFlag" v-bind:style="hide ? 'display:none' : 'display:block'"
        @click="workupBtnElementClick">
        <div class="workup-launcher-open-icon" v-if="workupIconImg != ''">
          <!-- <img class="chatbot-icon-image" :src="workupIconImg" alt="chatbotIconImage" /> -->
          <i class="v-icon icon-icon_chatbot"></i>
        </div>
      </div>
      <!-- <div id="chatbotBtn" class="workup-launcher-hide-icon" @click="hideChabot">
        <img class="btn-chatbot-close" :src="workupCloseIconImg" alt="chatbotClose" />
      </div> -->
    </div>
    <div id="chatbotTopBtn" class="workup-launcher-show-icon mt-1 pr-2" @click="workupBtnElementClick">
      <img class="chatbot-icon-image" width="0px" height="0px" :src="workupOpenIconImg" alt="chatbotIconImage" />
    </div>


  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import ChatBody from "@/views/ChatBody.vue";
import ChatStatusMsg from "@/views/ChatStatusMsg.vue";
import { getTokenFromCookie } from '@/utils/cookies';
import workupIconImg from "@/assets/img/chatBtn/icon_workup_bi_2x.png";
// import workupCloseIconImg from "@/assets/img/chatBtn/icon_close_2x.png";
import workupOpenIconImg from "@/assets/img/chatBtn/open.png";

const firstClick = ref(false);
const hide = ref(false);
// const workupBg = "#007bff";
// const workupBg = "#007bff";
// const workupBg = "#9CC840";
const workupLauncherReadyFlag = ref(false);
const workupChatOpenFlag = ref(false);
const tenantKey = ref("")
function workupBtnElementClick() {

  //웰컴메세지 확인 용 
  if (!firstClick.value) {
    firstClick.value = true;
  }

  //숨겨진 상태
  if (hide.value) {
    hide.value = false;
    workupChatOpenFlag.value = false;
  }

  tenantKey.value = getTokenFromCookie('tenantKey');
  workupChatOpenFlag.value = !workupChatOpenFlag.value;

  var bodyElement = document.body;
  if (bodyElement.classList.contains("workup-opened")) {
    bodyElement.classList.remove("workup-opened");
  } else {
    bodyElement.classList.add("workup-opened");
  }
}

// function hideChabot() {
//   hide.value = !hide.value;
//   if (workupChatOpenFlag.value)
//     workupChatOpenFlag.value = true;
// }

onMounted(() => {
  setTimeout(() => {
    workupLauncherReadyFlag.value = true;
  }, 1000);
})
</script>